module.exports = __webpack_public_path__ + "img/icon-scatter.96863874.png";